import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = chargement, false = invité

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  // Une erreur 404/5xx ponctuelle (redémarrage du serveur) ne doit jamais bloquer une inscription
  const postWithRetry = async (url, payload) => {
    try {
      return await api.post(url, payload);
    } catch (e) {
      const status = e?.response?.status;
      if (status && status < 500 && status !== 404) throw e;
      await new Promise((r) => setTimeout(r, 2000));
      return api.post(url, payload);
    }
  };

  const login = async (email, password) => {
    const { data } = await postWithRetry("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await postWithRetry("/auth/register", payload);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* session déjà invalide */ }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
